module.exports = __webpack_public_path__ + "static/media/error-icon.99cf3009.svg";